import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../models/user";
import { UserThunk } from "./thunks";

interface UserState {
  user: User;
  loading: boolean;
  error: string | null;
}

const emptyUser = {
  username: "",
  email: "",
  firstName: "",
  lastName: "",
  title: "",
  timezone: "America/Chicago",
  language: "",
  isAuthenticated: false
};

export const initialState: UserState = {
  user: emptyUser,
  loading: false,
  error: null
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUser: state => {
      state.user.isAuthenticated = true;
      state.loading = false;
    },
    clearUser: state => {
      state = initialState;
    }
  },
  extraReducers: builder => {
    builder.addCase(UserThunk.fulfilled, (state, action) => {
      const user = action.payload as User;
      if (!user) {
        state.loading = false;
        state.user = emptyUser;
        state.error = "user not authenticated";
        return;
      }
      state.user = user;
      state.user.isAuthenticated = true;
      state.loading = false;
      state.error = "";
    });
    builder.addCase(UserThunk.rejected, (state, action) => {
      state.loading = false;
      state.user = emptyUser;
      state.error = "user not authenticated";
    });
    builder.addCase(UserThunk.pending, (state, action) => {
      state.user = emptyUser;
      state.error = "";
      state.loading = true;
    });
  }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
